import { Button, Center, Flex, Text } from '@chakra-ui/react'
import { colors, FieldMap } from '@hb/shared'
import { useMemo } from 'react'
import { LoadingOverlay } from '../LoadingOverlay'
import { useGynCareView } from './context'
import { StageProgress } from './StageProgress'

const StageLabel = ({
  isLoading,
  name,
  active,
  complete,
  width,
  first,
  last,
}: {
  isLoading: boolean
  name: string
  active: boolean
  complete: boolean
  width: number
  first: boolean
  last: boolean
}) => (
  <Center
    boxShadow={active ? 'inset 0 0 4px 3px #55e0b8' : 'none'}
    h="50px"
    // bg={complete ? colors.green.hex : '#f7f7f7'}
    bg={complete ? `${colors.green.hex}cc` : '#dfdfdf'}
    border="1px solid"
    borderColor={complete ? `${colors.green.hex}ff` : '#cacaca'}
    // borderRadius={6}
    borderLeftRadius={first ? 6 : 0}
    borderRightRadius={last ? 6 : 0}
    px={2}
    py={2}
    transition="background-color 300ms"
    w={`${width}px`}>
    <Text
      fontFamily="Hero-New"
      lineHeight={1.1}
      // maxW="100%"
      fontSize={name.length > 10 ? 'sm' : 'md'}
      fontWeight={500}
      textShadow={complete ? '1px 1px 3px #00000055' : 'none'}
      color={complete ? 'white' : 'gray.500'}
      transition="opacity 300ms"
      // opacity={complete || active ? 1 : 0.7}
      whiteSpace="pre-wrap"
      // whiteSpace="break-spaces"
      textAlign="center"
      borderRadius="full">
      {name}
    </Text>
    <LoadingOverlay loading={isLoading} />
  </Center>
)

// const StageCircle = ({
//   width,
//   index,
//   active,
//   first,
//   last,
// }: {
//   width: number
//   index: number
//   active: boolean
//   first: boolean
//   last: boolean
// }) => {
//   const { stages, formStatus } = useGynCareView()
//   const stageId = stages[index].id
//   const complete = formStatus.stages[stageId]?.complete ?? false
//   const prevStageId = index > 0 ? stages[index - 1].id : null
//   const prevComplete = prevStageId ? (formStatus.stages[prevStageId]?.complete ?? false) : true
//   const height = useMemo(() => width / 2.5, [width])
//   return (
//     <svg width={width} height={height} viewBox={`-${width / 2} -${height / 2} ${width} ${height}`}>
//       {first ? null : (
//         <>
//           <rect x={-width / 2} y={-6} width={width / 2} height={12} fill="#e5e5e5" />
//           <rect
//             x={-width / 2}
//             y={-2}
//             width={width / 2}
//             height={4}
//             fill={prevComplete ? colors.green.hex : '#999999'}
//           />
//         </>
//       )}
//       {last ? null : (
//         <>
//           <rect x={0} y={-6} width={width / 2} height={12} fill="#e5e5e5" />
//           <rect
//             x={0}
//             y={-2}
//             width={width / 2}
//             height={4}
//             fill={complete ? colors.green.hex : '#999999'}
//           />
//         </>
//       )}
//       <circle fill="#e5e5e5" cx={0} cy={0} r={height * 0.4} />
//       <circle
//         style={{ transition: 'opacity 300ms' }}
//         opacity={active ? 1 : 0}
//         fill="#f8f8f8"
//         cx={0}
//         cy={0}
//         r={height * 0.35}
//       />
//       <path
//         d="M -6.555 16.086 L -21.804 0.836 L -17.993 -2.976 L -6.555 8.461 L 17.992 -16.086 L 21.803 -12.273 L -6.555 16.086 Z"
//         fill={complete ? colors.green.hex : '#999999'}
//         transform={`scale(${height / 100})`}
//       />
//     </svg>
//   )
// }

const DesktopGynStageButton = ({
  stage,
  circleWidth,
  first,
  last,
  index,
  onSelect,
  isActive,
}: {
  stage: FieldMap
  circleWidth: number
  first: boolean
  last: boolean
  index: number
  onSelect: () => void
  isActive: boolean
}) => {
  const { stages, formStatus, pendingStageIndex } = useGynCareView()
  const stageId = stages[index].id
  const complete = formStatus.stages[stageId]?.complete ?? false
  return (
    <Button
      variant="unstyled"
      display="flex"
      flexDirection="row"
      h="auto"
      borderRadius={0}
      minW="0"
      alignItems="center"
      width={`${circleWidth}px`}
      onClick={onSelect}>
      <StageLabel
        active={isActive}
        name={stage.name}
        complete={complete}
        isLoading={pendingStageIndex === index}
        width={circleWidth}
        first={first}
        last={last}
      />
      {/* <StageCircle active={isActive} index={index} width={circleWidth} first={first} last={last} /> */}
    </Button>
  )
}

export const DesktopGynStageList = ({ width }: { width: number }) => {
  const { stages, stageIndex, handleStageSelect } = useGynCareView()

  const circleWidth = useMemo(() => Math.min(135, width / stages.length), [width, stages])

  return (
    <Flex
      justifyContent="center"
      alignItems="flex-end"
      w="100%"
      filter="drop-shadow(0 0 3px #00000066)">
      <Flex flexFlow="column" gap={2}>
        <Flex bg="#efefef" p={1} borderRadius={6} gap={1} alignItems="center">
          {stages.map((s, index) => (
            <DesktopGynStageButton
              stage={s}
              circleWidth={circleWidth}
              first={index === 0}
              key={s.id}
              isActive={stageIndex === index}
              onSelect={() => handleStageSelect(index)}
              index={index}
              last={index === stages.length - 1}
            />
          ))}
        </Flex>
        <StageProgress />
      </Flex>
    </Flex>
  )
}
